import { CriticalGeometryArtifactViewer } from '@/components/CriticalGeometryArtifactViewer/CriticalGeometryArtifactViewer';
import { usePageTitle } from '@/hooks/usePageTitle';
import { useParams } from 'react-router-dom';

export const CriticalGeometryArtifactPage = () => {
  const { assetId, artifactId } = useParams();
  usePageTitle('Critical geometry file');

  if (!assetId || !artifactId) {
    return;
  }
  return <CriticalGeometryArtifactViewer assetId={assetId} artifactId={artifactId} />;
};
